export default "__VITE_ASSET__pBsMB_4D__"